import PropTypes from 'prop-types';
import { Title } from '@mantine/core';
import styles from './style.module.css';
import ViewLine from '../ViewLine';

const SectionView = (props) => {
  const { title, lines = [], autoFit } = props;
  const normalizedLines = Array.isArray(lines[0]) ? lines : [lines];

  return (
    <section className={styles.section}>
      {title && (
        <header className={styles.sectionTitle}>
          <Title order={4}>{title}</Title>
        </header>
      )}

      {normalizedLines.map((lineGroup, index) => (
        <div key={index} className={styles.lineGroup}>
          <ViewLine lines={lineGroup} autoFit={autoFit } />
        </div>
      ))}
    </section>
  );
};

SectionView.propTypes = {
  title: PropTypes.string,
  lines: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.any,
      }),
    ),
    PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.any,
        }),
      ),
    ),
  ]),
  autoFit: PropTypes.bool,
};

export default SectionView;
